import { useEffect } from "react";
import { useSite } from "../context/SiteContext";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/** Sets document title, description, Open Graph tags and canonical URL for the current page. */
const Seo = ({ title, description, image }) => {
  const { config } = useSite();

  useEffect(() => {
    const fullTitle = title ? `${title} | ${config.name}` : config.name;
    const desc = description || config.description;
    const url = window.location.origin + window.location.pathname;

    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    setMeta(
      "property",
      "og:image",
      window.location.origin + (image || config.images.shareDefault),
    );
    setCanonical(url);
  }, [title, description, image, config]);

  return null;
};

export default Seo;
